import {PayoffChart, tfPayoffChart} from "./payoff-chart/PayoffChartComponent";
import {payoffDiagram, PayoffDiagram} from "./payoff-diagram/PayoffDiagramComponent";
import {payoffMatrix, PayoffMatrix} from "./payoff-matrix/PayoffMatrixComponent";
import {PayoffService} from "./service/PayoffService";
import {payoffMatrixGrid, PayoffMatrixGrid} from "./payoff-matrix/components/grid/PayoffMatrixGridComponent";
import {
    payoffDiagramTopControls,
    PayoffDiagramTopControls
} from "./payoff-diagram/components/top-controls/PayoffDiagramControlsComponent";
import {
    payoffDiagramControlsRight,
    PayoffDiagramControlsRight
} from "./payoff-diagram/components/payoff-diagram-right/PayoffDiagramControlsRightComponent";
import {payoffDiagramZoom, PayoffDiagramZoom} from "./payoff-diagram/components/zoom/PayoffDiagramZoomComponent";
import {volSelect, VolSelect} from "./vol-select/PayoffVolSelectorComponent";
import {
    priceIncrement,
    PriceIncrement
} from "./payoff-matrix/components/price-increments/PayoffMatrixPriceIncrementComponent";

export default angular.module("tfApp.components.charts.payoff", [])
                      .component(PayoffChart, tfPayoffChart())
                      .component(PayoffDiagram, payoffDiagram())
                      .component(PayoffDiagramTopControls, payoffDiagramTopControls())
                      .component(PayoffDiagramControlsRight, payoffDiagramControlsRight())
                      .component(PayoffDiagramZoom, payoffDiagramZoom())
                      .component(PayoffMatrix, payoffMatrix())
                      .component(PayoffMatrixGrid, payoffMatrixGrid())
                      .component(VolSelect, volSelect())
                      .component(PriceIncrement, priceIncrement())
                      .service(PayoffService.id, PayoffService)
                      .name;
